export default __webpack_public_path__ + "static/media/1st edition bookcover.28eeb6c3.png";